import { inject, Injectable, signal } from '@angular/core';
import { IntroService } from '@app/core/infrastructure/third-party';
import { TableTourConfig } from '@app/shared/types/ui';

@Injectable({
  providedIn: 'root'
})
export class TableTourService {
  private readonly introService = inject(IntroService);
  private readonly registeredTours = signal<Record<string, TableTourConfig>>({});

  registerTableTour(tourId: string, config: TableTourConfig): void {
    this.registeredTours.update(tours => ({
      ...tours,
      [tourId]: config
    }));

    this.introService.registerTour(tourId, {
      name: config.name,
      steps: config.steps
    });
  }

  async startTableTour(tourId: string): Promise<{ completed: boolean }> {
    const tours = this.registeredTours();

    if (!tours[tourId]) {
      return { completed: false };
    }

    return this.introService.startTour(tourId);
  }

  hasTour(tourId: string): boolean {
    return tourId in this.registeredTours();
  }

  getRegisteredTourIds(): string[] {
    return Object.keys(this.registeredTours());
  }
}
